import hasStartedPlanUtil from '../has-started'
import isLoggedPlanUtil from '../is-logged'

function hasStartedAndNotEndedPlanUtil (plan) {
  return !isLoggedPlanUtil(plan) && hasStartedPlanUtil(plan)
}

export default hasStartedAndNotEndedPlanUtil
